import { useMemo } from "react";
import PropTypes from "prop-types";
import { getLocalPartiName, getParticipantIndex } from "../../../../shared/dataTrackFunction";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import { useSelector } from "react-redux";

const StreamingParticipantName = ({ localisedValues }) => {
    const { streamingPartiIdentity } = useSelector((state) => state.twilioEvents);

    const streamingUserName = useMemo(() => {
        let partiName = getParticipantIndex(streamingPartiIdentity);
        if (streamingPartiIdentity == CALL_DATA.localIdentity) {
            partiName = getLocalPartiName();
            if (CALL_DATA.participantUserName && !GLOBAL_MEETING_DATA.isAgent) {
                partiName = CALL_DATA.participantUserName + " " + localisedValues["you"];
            }
        }
        return partiName;
    }, [streamingPartiIdentity]);

    return (
        <div className='video-participant-name'>
            <span className='name'>{streamingUserName}</span>
        </div>
    );
};
StreamingParticipantName.propTypes = {
    localisedValues: PropTypes.any,
};
export default StreamingParticipantName;
